module.exports = __webpack_public_path__ + "static/tetleys-china-olympic-team-sm-5194b5bb201e2e8a1d74fec35a39e5f3.jpg";